// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#LayerTree span.layertree-tree-visibility {
    margin: 0 0.5em;
    color: var(--titlebar-bg-color);
}

#LayerTree span.layertree-tree-visibility:before {
    background-color: var(--titlebar-text-color);
}

#LayerTree span.layertree-print-legend,
#LayerTree span.layertree-visible-filter,
#LayerTree span.layertree-delete-legend,
#LayerTree span.layertree-theme-metadata {
    margin-left: 0.5em;
    padding: 0.25em;
}

#LayerTree span.layertree-print-legend:hover,
#LayerTree span.layertree-visible-filter:hover,
#LayerTree span.layertree-delete-legend:hover,
#LayerTree span.layertree-theme-metadata:hover {
    background-color: var(--titlebar-text-color);
    color: var(--titlebar-bg-color);
}

#LayerTree span.layertree-visible-filter-active {
    background-color: var(--titlebar-text-color);
    color: var(--titlebar-bg-color);
}

/* https://github.com/philipwalton/flexbugs/issues/216 */
#LayerTree div.layertree-container-wrapper {
    display: flex;
    flex-direction: row;
}

#LayerTree div.layertree-container {
    flex: 0 0 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    /* titlebar: 2.5em */
    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/
}

#LayerTree div.layertree-tree {
    min-height: 5em;
    flex: 0 1 auto;
    overflow-y: auto;
    margin-right: 0.25em;
    -webkit-user-select: none;
    user-select: none;
}

#LayerTree div.layertree-tree .drop-ghost {
    outline: 1px solid var(--color-active);
    background-color: var(--container-bg-color);
    color: var(--text-color);
}

#LayerTree div.layertree-option {
    flex: 0 0 auto;
    height: 2.25em;
    padding: 0.25em 0.5em 0.25em 0.5em;
    border-top: 1px solid var(--border-color);
    display: flex;
    align-items: center;
}

#LayerTree div.layertree-option > span.icon {
    margin-right: 0.5em;
}

#LayerTree div.layertree-option > span {
    cursor: pointer;
}

#LayerTree div.layertree-item-container {
    margin-left: 0.5em;
}

#LayerTree div.layertree-item {
    display: flex;
    align-items: center;
    height: 1.75em;
}

#LayerTree div.layertree-item-disabled > span.layertree-item-title {
    color: var(--text-color-disabled);
}

#LayerTree div.layertree-item-outsidescalerange > span.layertree-item-title {
    font-style: italic;
    color: var(--text-color-disabled);
}

#LayerTree div.layertree-item-separator {
    font-weight: bold;
    border-bottom: 1px solid var(--color-active);
}

#LayerTree div.layertree-item-separator > input {
    border: none;
    background-color: transparent;
    width: 100%;
    font-weight: bold;
}

#LayerTree div.layertree-item-separator > input:focus {
    background-color: var(--input-bg-color);
}

#LayerTree span.layertree-item-expander {
    margin-right: 0.25em;
    flex: 0 0 1em;
}

#LayerTree div.layertree-item > div.spinner {
    width: 1em;
    height: 1em;
    flex: 0 0 auto;
    margin-right: 0.5em;
}

#LayerTree span.layertree-item-checkbox {
    margin-right: 0.5em;
    flex: 0 0 auto;
}

#LayerTree img.layertree-item-legend-thumbnail {
    height: 1.5em;
    width: auto;
    max-width: 2em;
    margin-right: 0.5em;
    border: 1px solid var(--border-color);
    background-color: white;
    flex: 0 0 auto;
}

#LayerTree span.layertree-item-legend-coloricon {
    display: inline-block;
    height: 1.5em;
    width: 1.5em;
    margin-right: 0.5em;
    border: 1px solid var(--border-color);
    flex: 0 0 auto;
}

img.layertree-item-legend-tooltip {
    position: absolute;
    z-index: 6;
    box-shadow: 0px 2px 5px rgba(136, 136, 136, 0.5);
    border-radius: 0.5em;
    border: 1px solid var(--border-color);
    margin-left: 1px;
    padding: 0.25em;
    background-color: white;
}

#LayerTree span.layertree-item-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 1 auto;
}

#LayerTree div.layertree-item-noresults {
    color: gray;
    font-size: small;
    font-style: italic;
}

#LayerTree span.layertree-item-queryable {
    margin-left: 0.25em;
    color: var(--border-color);
    font-size: xx-small;
    vertical-align: top;
    flex: 0 0 auto;
}

#LayerTree span.layertree-item-spacer {
    flex: 1 1 auto;
}

#LayerTree span.layertree-item-remove {
    text-align: center;
    width: 1.75em;
    flex: 0 0 auto;
}

#LayerTree span.layertree-item-remove:hover {
    color: red;
}

#LayerTree span.layertree-item-menubutton {
    text-align: center;
    width: 1.75em;
    flex: 0 0 auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

#LayerTree span.layertree-item-menubutton-active {
    background-color: var(--color-active);
    color: white;
}

#LayerTree div.layertree-item-optionsmenu {
    margin-left: 1em;
    height: 1.75em;
    display: flex;
    align-items: center;
    border: 1px solid var(--border-color);
    background-color: var(--input-bg-color);
}

#LayerTree div.layertree-item-optionsmenu > span.icon {
    flex: 0 0 auto;
    width: 1.75em;
    text-align: center;
}

#LayerTree input.layertree-item-transparency-slider {
    flex: 1 1 auto;
    font-size: small;
    min-width: 0;
    max-width: none;
    width: 1000em; /* exagerated value */
    margin: 0 0.25em;
}

#LayerTree div.layertree-item-stylemenu {
    margin-left: 1em;
    border: 1px solid var(--border-color);
    background-color: var(--input-bg-color);
}

#LayerTree div.layertree-item-stylemenu > div {
    padding: 0.25em;
    display: flex;
    align-items: center;
}

#LayerTree div.layertree-item-stylemenu > div > span.icon {
    margin-right: 0.25em;
}

#LayerTree div.layertree-item-stylemenu > div > div {
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
}


#LayerTree div.layertree-item-addsep {
    border-top: 2px solid transparent;
    border-bottom: 4px solid transparent;
    margin-bottom: -6px;
    position: relative;
}

#LayerTree div.layertree-item-addsep:hover {
    border-top: 2px solid var(--color-active);
}
`, "",{"version":3,"sources":["webpack://./../qwc2/plugins/style/LayerTree.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,4CAA4C;AAChD;;AAEA;;;;IAII,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;;;IAII,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA,wDAAwD;AACxD;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,gFAAgF,EAAE,oDAAoD;IACtI,+FAA+F,EAAE,oDAAoD;AACzJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,sCAAsC;IACtC,2CAA2C;IAC3C,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kCAAkC;IAClC,yCAAyC;IACzC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,qCAAqC;IACrC,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gDAAgD;IAChD,oBAAoB;IACpB,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa,EAAE,qBAAqB;IACpC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;;AAGA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":["#LayerTree span.layertree-tree-visibility {\n    margin: 0 0.5em;\n    color: var(--titlebar-bg-color);\n}\n\n#LayerTree span.layertree-tree-visibility:before {\n    background-color: var(--titlebar-text-color);\n}\n\n#LayerTree span.layertree-print-legend,\n#LayerTree span.layertree-visible-filter,\n#LayerTree span.layertree-delete-legend,\n#LayerTree span.layertree-theme-metadata {\n    margin-left: 0.5em;\n    padding: 0.25em;\n}\n\n#LayerTree span.layertree-print-legend:hover,\n#LayerTree span.layertree-visible-filter:hover,\n#LayerTree span.layertree-delete-legend:hover,\n#LayerTree span.layertree-theme-metadata:hover {\n    background-color: var(--titlebar-text-color);\n    color: var(--titlebar-bg-color);\n}\n\n#LayerTree span.layertree-visible-filter-active {\n    background-color: var(--titlebar-text-color);\n    color: var(--titlebar-bg-color);\n}\n\n/* https://github.com/philipwalton/flexbugs/issues/216 */\n#LayerTree div.layertree-container-wrapper {\n    display: flex;\n    flex-direction: row;\n}\n\n#LayerTree div.layertree-container {\n    flex: 0 0 100%;\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    /* titlebar: 2.5em */\n    max-height: calc(100vh - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n    max-height: calc(var(--vh, 1vh) * 100 - 2.5em - var(--topbar-height) - var(--bottombar-height)); /* viewport - sidebar_titlebar - topbar - bottombar*/\n}\n\n#LayerTree div.layertree-tree {\n    min-height: 5em;\n    flex: 0 1 auto;\n    overflow-y: auto;\n    margin-right: 0.25em;\n    -webkit-user-select: none;\n    user-select: none;\n}\n\n#LayerTree div.layertree-tree .drop-ghost {\n    outline: 1px solid var(--color-active);\n    background-color: var(--container-bg-color);\n    color: var(--text-color);\n}\n\n#LayerTree div.layertree-option {\n    flex: 0 0 auto;\n    height: 2.25em;\n    padding: 0.25em 0.5em 0.25em 0.5em;\n    border-top: 1px solid var(--border-color);\n    display: flex;\n    align-items: center;\n}\n\n#LayerTree div.layertree-option > span.icon {\n    margin-right: 0.5em;\n}\n\n#LayerTree div.layertree-option > span {\n    cursor: pointer;\n}\n\n#LayerTree div.layertree-item-container {\n    margin-left: 0.5em;\n}\n\n#LayerTree div.layertree-item {\n    display: flex;\n    align-items: center;\n    height: 1.75em;\n}\n\n#LayerTree div.layertree-item-disabled > span.layertree-item-title {\n    color: var(--text-color-disabled);\n}\n\n#LayerTree div.layertree-item-outsidescalerange > span.layertree-item-title {\n    font-style: italic;\n    color: var(--text-color-disabled);\n}\n\n#LayerTree div.layertree-item-separator {\n    font-weight: bold;\n    border-bottom: 1px solid var(--color-active);\n}\n\n#LayerTree div.layertree-item-separator > input {\n    border: none;\n    background-color: transparent;\n    width: 100%;\n    font-weight: bold;\n}\n\n#LayerTree div.layertree-item-separator > input:focus {\n    background-color: var(--input-bg-color);\n}\n\n#LayerTree span.layertree-item-expander {\n    margin-right: 0.25em;\n    flex: 0 0 1em;\n}\n\n#LayerTree div.layertree-item > div.spinner {\n    width: 1em;\n    height: 1em;\n    flex: 0 0 auto;\n    margin-right: 0.5em;\n}\n\n#LayerTree span.layertree-item-checkbox {\n    margin-right: 0.5em;\n    flex: 0 0 auto;\n}\n\n#LayerTree img.layertree-item-legend-thumbnail {\n    height: 1.5em;\n    width: auto;\n    max-width: 2em;\n    margin-right: 0.5em;\n    border: 1px solid var(--border-color);\n    background-color: white;\n    flex: 0 0 auto;\n}\n\n#LayerTree span.layertree-item-legend-coloricon {\n    display: inline-block;\n    height: 1.5em;\n    width: 1.5em;\n    margin-right: 0.5em;\n    border: 1px solid var(--border-color);\n    flex: 0 0 auto;\n}\n\nimg.layertree-item-legend-tooltip {\n    position: absolute;\n    z-index: 6;\n    box-shadow: 0px 2px 5px rgba(136, 136, 136, 0.5);\n    border-radius: 0.5em;\n    border: 1px solid var(--border-color);\n    margin-left: 1px;\n    padding: 0.25em;\n    background-color: white;\n}\n\n#LayerTree span.layertree-item-title {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 0 1 auto;\n}\n\n#LayerTree div.layertree-item-noresults {\n    color: gray;\n    font-size: small;\n    font-style: italic;\n}\n\n#LayerTree span.layertree-item-queryable {\n    margin-left: 0.25em;\n    color: var(--border-color);\n    font-size: xx-small;\n    vertical-align: top;\n    flex: 0 0 auto;\n}\n\n#LayerTree span.layertree-item-spacer {\n    flex: 1 1 auto;\n}\n\n#LayerTree span.layertree-item-remove {\n    text-align: center;\n    width: 1.75em;\n    flex: 0 0 auto;\n}\n\n#LayerTree span.layertree-item-remove:hover {\n    color: red;\n}\n\n#LayerTree span.layertree-item-menubutton {\n    text-align: center;\n    width: 1.75em;\n    flex: 0 0 auto;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#LayerTree span.layertree-item-menubutton-active {\n    background-color: var(--color-active);\n    color: white;\n}\n\n#LayerTree div.layertree-item-optionsmenu {\n    margin-left: 1em;\n    height: 1.75em;\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--border-color);\n    background-color: var(--input-bg-color);\n}\n\n#LayerTree div.layertree-item-optionsmenu > span.icon {\n    flex: 0 0 auto;\n    width: 1.75em;\n    text-align: center;\n}\n\n#LayerTree input.layertree-item-transparency-slider {\n    flex: 1 1 auto;\n    font-size: small;\n    min-width: 0;\n    max-width: none;\n    width: 1000em; /* exagerated value */\n    margin: 0 0.25em;\n}\n\n#LayerTree div.layertree-item-stylemenu {\n    margin-left: 1em;\n    border: 1px solid var(--border-color);\n    background-color: var(--input-bg-color);\n}\n\n#LayerTree div.layertree-item-stylemenu > div {\n    padding: 0.25em;\n    display: flex;\n    align-items: center;\n}\n\n#LayerTree div.layertree-item-stylemenu > div > span.icon {\n    margin-right: 0.25em;\n}\n\n#LayerTree div.layertree-item-stylemenu > div > div {\n    flex: 1 1 auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n\n#LayerTree div.layertree-item-addsep {\n    border-top: 2px solid transparent;\n    border-bottom: 4px solid transparent;\n    margin-bottom: -6px;\n    position: relative;\n}\n\n#LayerTree div.layertree-item-addsep:hover {\n    border-top: 2px solid var(--color-active);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
